/*
 * site.ts — entry point for the Wedding public-site bundle. No jQuery.
 * esbuild bundles the feature modules below into wwwroot/js/dist/site.js.
 */

import { initCountdown } from "./countdown";
import { initNav } from "./nav";
import { initReveal } from "./reveal";
import { initEffects } from "./effects";
import { initMaps } from "./maps";
import { initGuideLightbox } from "./guide";
import { initAlbum } from "./album/index";
import { initUpload } from "./upload";
import { initFaq } from "./faq";

function ready(fn: () => void): void {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fn, { once: true });
  } else {
    fn();
  }
}

ready(() => {
  document.documentElement.classList.add("js");
  initNav();
  initCountdown();
  initReveal();
  initEffects();
  initMaps();
  initGuideLightbox();
  initAlbum();
  initUpload();
  initFaq();
});

export {};
